import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M2 4a1 1 0 011-1h18a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4zm2 1v14h16V5H4zm2 10h12v2H6v-2zm8-8h4v2h-4V7zm0 4h4v2h-4v-2z"/>
    <path fill="#34CEFF" fillRule="evenodd" d="M6 7h6v6H6V7zm2 4V9h2v2H8z" clipRule="evenodd"/>
  </SvgIcon>
);